import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

/**
 * Button to promote the London Book Fair App Demo experience
 * Only shown when the lbf=true parameter is in the URL
 * 
 * @param {Object} props
 * @param {Function} props.onAppDemoClick - Optional callback when the app demo button is clicked
 */
const LbfAppDemoButton = ({ onAppDemoClick }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const showLbf = searchParams.get('lbf') === 'true';
    
    if (!showLbf) return null;
    
    const handleButtonClick = () => {
        if (onAppDemoClick) {
            onAppDemoClick();
        } else {
            navigate('/app-wizard');
        }
    };
    
    return (
        <div className="mb-8 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-lg overflow-hidden shadow-xl">
            <div className="relative p-6 pb-24 md:pb-6 md:pr-48 text-white">
                {/* Background sparkle pattern */}
                <div 
                    className="absolute inset-0 opacity-10"
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 3L13.4 8.6H19L14.8 12.4L16.2 18L12 14.2L7.8 18L9.2 12.4L5 8.6H10.6L12 3Z' fill='white'/%3E%3C/svg%3E")`,
                        backgroundSize: '24px 24px'
                    }}
                ></div>

                {/* Mobile image */}
                <div className="absolute bottom-0 right-0 md:right-6 w-32 md:w-48 h-32 md:h-full flex items-end">
                    <img 
                        src="/images/app-preview.png" 
                        alt="App Demo Preview" 
                        className="object-contain max-h-full"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>

                <h2 className="text-xl md:text-2xl font-bold mb-2 relative">
                    London Book Fair Special Demo
                </h2>
                
                <div className="relative">
                    <p className="mb-4 max-w-md text-white/90">
                        See how quickly we can create a branded mobile app for your organization. 
                        Try our interactive app builder now!
                    </p>
                    
                    <button
                        onClick={handleButtonClick}
                        className="px-5 py-2.5 bg-white text-purple-700 rounded-lg font-medium hover:bg-gray-100 transition-colors shadow-sm flex items-center"
                    >
                        <Sparkles className="w-5 h-5 mr-2" />
                        Build My App Demo
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LbfAppDemoButton; 